import React, { useState, useEffect } from "react";
import { Col, Row, Card, Container, Breadcrumb, Table } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import config from "../../config";
import nouserImg from "../../assets/images/no_user.png";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { toWords } from "number-to-words";
import { Sidebar } from 'primereact/sidebar';
import { Badge } from 'primereact/badge';
const AdminLeadList = () => {
    const { accessToken } = useAuth();
    const [groupedLeads, setGroupedLeads] = useState({});
    const [loading, setLoading] = useState(false);
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [newStatus, setNewStatus] = useState("");
    const [formData, setFormData] = useState({});
    const statuses = ["Sent", "Contacted", "Converted", "Closed", "Cancelled"];
    const [expandedRows, setExpandedRows] = useState({});

    const toggleExpand = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };
    const currencySymbols = {
        INR: "₹ ",
        USD: "$ ",
        GBP: "£ ",
        EUR: "€ ",
        AED: "د.إ ",
        AUD: "A$ ",
        CAD: "C$ "
    };

    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode; // Default to currency code if not found
    };


    // ✅ New state for client search
    const [clientSearch, setClientSearch] = useState("");
    const [clientResults, setClientResults] = useState([]);
    const [clientLoading, setClientLoading] = useState(false);

    // ✅ New states for invoice search
    const [invoiceResults, setInvoiceResults] = useState([]);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [visibleRight, setVisibleRight] = useState(false);
    const [visibleRight2, setVisibleRight2] = useState(false);


    // ✅ Fetch grouped leads
    const fetchGroupedLeads = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${config.apiBASEURL}/Client_LeadRoutes/fetchallleads`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            setGroupedLeads(response.data.groupedLeads || {});
        } catch (error) {
            console.error("Error fetching grouped leads:", error);
        } finally {
            setLoading(false);
        }
    };

    const getSeverity = (status) => {
        switch (status) {
            case "Sent":
                return "info";
            case "Contacted":
                return "primary"; // PrimeReact supports 'primary' in recent versions
            case "Converted":
                return "success";
            case "Closed":
                return "secondary"; // can use 'help' or 'warning' if 'secondary' not supported
            default:
                return "danger";
        }
    };

    useEffect(() => {
        fetchGroupedLeads();
    }, []);


    // ✅ Handle status change click
    const handleChangeStatusClick = (lead) => {
        setSelectedLead(lead);
        setNewStatus(lead.status);
        setFormData({});
        setVisibleDialog(true);
    };


    const handleleadviewClick = (lead) => {
        setSelectedLead(lead);
        setVisibleRight2(true);
    }


    useEffect(() => {
        if (formData.final_amount && formData.percentage) {
            const commission = (formData.final_amount * formData.percentage) / 100;
            setFormData((prev) => ({ ...prev, commission_amount: commission }));
        }
    }, [formData.final_amount, formData.percentage]);


    // ✅ Fetch clients by query
    const fetchClients = async (searchTerm) => {
        if (!searchTerm || searchTerm.trim().length < 2) {
            setClientResults([]);
            return;
        }

        try {
            setClientLoading(true);
            const response = await axios.get(`${config.apiBASEURL}/Client_LeadRoutes/search`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { query: searchTerm },
            });

            if (response.status === 200 && response.data.results) {
                setClientResults(response.data.results);
            } else {
                setClientResults([]);
            }
        } catch (error) {
            console.error("Error fetching client search results:", error);
            setClientResults([]);
        } finally {
            setClientLoading(false);
        }
    };



    // ✅ Handle update API call
    const handleStatusUpdate = async () => {
        try {
            const payload = { new_status: newStatus, ...formData };

            const response = await axios.put(
                `${config.apiBASEURL}/Client_LeadRoutes/change-status/${selectedLead.Client_lead_id}`,
                payload,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            setVisibleDialog(false);
            fetchGroupedLeads();
        } catch (error) {
            console.error("Error updating lead status:", error);
        }
    };

    // ✅ Fetch invoice using code + client_id
    const fetchInvoiceByCode = async (invoiceCode) => {
        if (!invoiceCode || !selectedLead?.Client_id) {
            alert("Please enter an invoice code and ensure the lead has a Client ID.");
            return;
        }

        try {
            setInvoiceLoading(true);
            const res = await axios.get(`${config.apiBASEURL}/Client_LeadRoutes/fetchinvoice`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: {
                    invoice_code: invoiceCode,
                    client_id: selectedLead.Client_id,
                },
            });

            if (res.status === 200) {
                const invoice = res.data;
                setSelectedInvoice(invoice); // Set the selected invoice
                setFormData((prev) => ({
                    ...prev,
                    invoice_id: invoice.invoice_id,
                    invoice_code: invoice.invoice_code,
                    final_amount: invoice.sub_total,
                }));
            }
        } catch (error) {
            console.error("Error fetching invoice:", error);
            alert(error.response?.data?.message || "Invoice not found for this client.");
        } finally {
            setInvoiceLoading(false);
        }
    };



    // ✅ Fields conditionally required based on status
    const renderExtraFields = () => {
        if (newStatus === "Converted") {
            return (
                <div className="mt-3">
                    <label className="fw-bold">Select Client</label>
                    <InputText
                        value={clientSearch}
                        onChange={(e) => {
                            const value = e.target.value;
                            setClientSearch(value);
                            fetchClients(value);
                        }}
                        placeholder="Search by Company or Billing Name"
                        className="w-100 mt-1"
                    />

                    {/* Show loading state */}
                    {clientLoading && <small className="text-muted d-block mt-1">Searching...</small>}

                    {/* Display search results */}
                    {clientResults.length > 0 && (
                        <div className="border rounded mt-2 p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                            {clientResults.map((client) => (
                                <div
                                    key={client.Client_details_id}
                                    className={`p-2 rounded mb-1 ${formData.client_id === client.Client_id ? "bg-light border" : ""}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setFormData({
                                            ...formData,
                                            Client_id: client.Client_id,
                                            client_name: client.comp_name,
                                        });
                                        setClientSearch(`${client.comp_name} (${client.bill_name})`);
                                        setClientResults([]); // hide list
                                    }}
                                >
                                    <strong>{client.comp_name}</strong>
                                    <br />
                                    <small>{client.bill_name}</small>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );
        }

        if (newStatus === "Closed") {
            return (
                <>
                    <Row>
                        <Col lg={12} xs={12} md={12} className="px-1 mt-3 d-flex justify-content-between align-items-end">
                            <div>
                                <label className="fw-bold">Enter Invoice Code</label>
                                <div className="d-flex gap-2 align-items-center">
                                    <InputText
                                        value={formData.invoice_code || ""}
                                        onChange={(e) => setFormData({ ...formData, invoice_code: e.target.value })}
                                        placeholder="Enter Invoice Code"
                                        className="w-100 mt-1"
                                    />
                                    <Button
                                        title="fetch"
                                        icon="pi pi-search"
                                        severity="info"
                                        text
                                        className="py-2"
                                        loading={invoiceLoading}
                                        onClick={() => fetchInvoiceByCode(formData.invoice_code)}
                                    />
                                </div>
                            </div>
                            {selectedInvoice ? (
                                <Button
                                    label="View Invoice"
                                    icon="pi pi-eye"
                                    severity="warning"
                                    outlined
                                    className="py-2"
                                    onClick={() => setVisibleRight(true)} // ✅ Open sidebar/modal
                                />
                            ) : null}
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Final Amount</label>
                            <InputNumber
                                value={formData.final_amount || ""}
                                onValueChange={(e) => setFormData({ ...formData, final_amount: e.value })}
                                className="w-100 mt-1"
                                placeholder="Enter or fetched from invoice"
                            />
                            {formData.invoice_id && (
                                <small className="text-muted">
                                    Fetched from Invoice <strong>{formData.invoice_code}</strong>
                                </small>
                            )}
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Percentage</label>
                            <InputNumber
                                value={formData.percentage || ""}
                                onValueChange={(e) => setFormData({ ...formData, percentage: e.value })}
                                className="w-100 mt-1"
                                suffix="%"
                                placeholder="Enter commission %"
                            />
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Commission Amount</label>
                            <InputNumber
                                value={formData.commission_amount || ""}
                                disabled
                                className="w-100 mt-1"
                            />
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Conversion Date</label>
                            <Calendar
                                value={formData.conversion_date || null}
                                onChange={(e) => setFormData({ ...formData, conversion_date: e.value })}
                                showIcon
                                dateFormat="yy-mm-dd"
                                className="w-100 mt-1"
                            />
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Payment Status</label>
                            <Dropdown
                                value={formData.payment_status || ""}
                                onChange={(e) => setFormData({ ...formData, payment_status: e.value })}
                                options={["Pending", "Completed"]}
                                placeholder="Select Status"
                                className="w-100 mt-1"
                            />
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Payment Mode</label>
                            <InputText
                                value={formData.payment_mode || ""}
                                onChange={(e) => setFormData({ ...formData, payment_mode: e.target.value })}
                                placeholder="Enter Mode (e.g., Bank Transfer)"
                                className="w-100 mt-1"
                            />
                        </Col>
                        <Col lg={6} xs={12} md={6} className="px-1 mt-3">
                            <label className="fw-bold">Payment Date</label>
                            <Calendar
                                value={formData.payment_date || null}
                                onChange={(e) => setFormData({ ...formData, payment_date: e.value })}
                                showIcon
                                dateFormat="yy-mm-dd"
                                className="w-100 mt-1"
                            />
                        </Col>
                    </Row>
                </>
            );
        }



        return null;
    };

    console.log("Grouped Leads:", selectedLead);
    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} xs={12} className="mb-4 d-lg-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Referrals</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="d-flex justify-content-end mt-3 mt-lg-0">
                            {/* <Button
                                label="Refferel"
                                icon="pi pi-plus"
                                className="border-0"
                                severity="help"
                                onClick={() => setVisibleRight(true)}
                            /> */}
                        </div>

                    </Col>
                    <Col lg={12}>
                        <Card className="p-3 border-0 shadow-sm referTab">
                            {loading ? (
                                <p>Loading leads...</p>
                            ) : (
                                <TabView>
                                    {statuses.map((status) => (
                                        <TabPanel 
                                            key={status} 
                                            header={
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                    <span>{status}</span>
                                                    <Badge value={groupedLeads[status]?.length || 0} severity="secondary" />
                                                </div>
                                            }
                                        >
                                            {groupedLeads[status]?.length > 0 ? (
                                                <Table size="sm" bordered hover responsive>
                                                    <thead>
                                                        <tr className="table-primary">
                                                            <th>#</th>
                                                            <th style={{ width: '220px' }}>Referrel</th>
                                                            <th style={{ width: '220px' }}>Contact</th>
                                                            <th>Requirement</th>
                                                            <th>Submitted By</th>
                                                            <th style={{ width: '100px', textAlign: 'center' }}>Status</th>
                                                            <th style={{ width: '100px', textAlign: 'center' }}>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {groupedLeads[status].map((lead, index) => (
                                                            <tr key={lead.client_lead_id}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <span className="d-block border-bottom pb-2 mb-2">
                                                                        <b>POC : </b>{lead.lead_name || "N/A"}
                                                                    </span>
                                                                    <span className="d-block">
                                                                        <b>Type : </b>{lead.lead_type || "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="d-block border-bottom pb-2 mb-2">
                                                                        <i className="pi pi-phone text-warning" style={{ fontSize: "13px", verticalAlign: "middle" }}></i> {lead.phone_no || "N/A"}
                                                                    </span>
                                                                    <span className="d-block">
                                                                        <i className="pi pi-envelope text-info" style={{ fontSize: "13px", verticalAlign: "middle" }}></i> {lead.email || "N/A"}
                                                                    </span>
                                                                </td>
                                                                {/* <td>{lead.requirement || "N/A"}</td> */}
                                                                <td>
                                                                    <div style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                                                                        {(expandedRows[lead.id] ? lead.requirement : lead.requirement?.slice(0, 80)) || "N/A"}
                                                                        {lead.requirement && lead.requirement.length > 80 && (
                                                                            <button
                                                                                onClick={() => toggleExpand(lead.id)}
                                                                                style={{
                                                                                    border: "none",
                                                                                    background: "none",
                                                                                    color: "#007bff",
                                                                                    cursor: "pointer",
                                                                                    padding: 0,
                                                                                    marginLeft: "5px",
                                                                                }}
                                                                            >
                                                                                {expandedRows[lead.id] ? "Less..." : "More..."}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <Image
                                                                            src={lead.leadOwner?.profileImage?.image_url || nouserImg}
                                                                            alt="User"
                                                                            width="35"
                                                                            height="35"
                                                                            className="rounded-circle me-2"
                                                                            preview
                                                                        />
                                                                        <div>
                                                                            <strong>
                                                                                {lead.leadOwner
                                                                                    ? `${lead.leadOwner.first_name} ${lead.leadOwner.last_name}`
                                                                                    : "N/A"}
                                                                            </strong>
                                                                            <br />
                                                                            <small>{lead.leadOwner?.email || "No Email"}</small>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="text-center">
                                                                    {/* <Badge
                                                                        bg={
                                                                            status === "Sent"
                                                                                ? "info"
                                                                                : status === "Contacted"
                                                                                    ? "primary"
                                                                                    : status === "Converted"
                                                                                        ? "success"
                                                                                        : status === "Closed"
                                                                                            ? "secondary"
                                                                                            : "danger"
                                                                        }
                                                                    >
                                                                        {status}
                                                                    </Badge> */}
                                                                    <Badge value={status} severity={getSeverity(status)} />
                                                                </td>
                                                                <td>
                                                                    <Button
                                                                        title="View"
                                                                        icon="pi pi-eye"
                                                                        className="border-0"
                                                                        severity="info"
                                                                        size="small"
                                                                        text
                                                                        onClick={() => handleleadviewClick(lead)}
                                                                    />
                                                                    <Button
                                                                        title="Change Status"
                                                                        icon="pi pi-tag"
                                                                        className="border-0"
                                                                        severity="warning"
                                                                        size="small"
                                                                        text
                                                                        onClick={() => handleChangeStatusClick(lead)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <p className="text-muted">No leads found in this category.</p>
                                            )}
                                        </TabPanel>
                                    ))}
                                </TabView>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Row>

            {/* ✅ Status Change Dialog */}
            <Dialog
                header={`Change Status for ${selectedLead?.lead_name || "Lead"}`}
                visible={visibleDialog}
                style={{ width: "30vw" }}
                modal
                onHide={() => setVisibleDialog(false)}
                footer={
                    <div>
                        <Button label="Cancel" severity="danger" icon="pi pi-times" onClick={() => setVisibleDialog(false)} text />
                        <Button label="Update" severity="success" icon="pi pi-check" onClick={handleStatusUpdate} autoFocus />
                    </div>
                }
            >
                <div>
                    <label className="fw-bold">Select New Status</label>
                    <Dropdown
                        value={newStatus}
                        onChange={(e) => setNewStatus(e.value)}
                        options={statuses.filter((s) => s !== "Draft")}
                        placeholder="Select Status"
                        className="w-100 mt-2"
                    />
                    {renderExtraFields()}
                </div>
            </Dialog>

            <Sidebar visible={visibleRight} position="right" onHide={() => {
                setVisibleRight(false);
                setSelectedInvoice(null); // ✅ Reset invoice when sidebar is closed
            }}
                className="resp_sidewidth" style={{ width: '50vw' }}>
                {selectedInvoice && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '0', fontFamily: 'Roboto', background: '#fff' }}>
                        <thead className={selectedInvoice?.status === "Cancelled" ? "cancelINV" : ""}>
                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                <td colspan="3" style={{ padding: '10px', Width: '300px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={selectedInvoice.logo_url || require("../../assets/images/logo.png")} alt="Company Logo" style={{ height: '170px', width: '170px', objectFit: 'contain' }} />
                                        <div style={{ width: 'calc(100% - 120px)', marginLeft: '30px' }}>
                                            <h2 style={{ margin: '5px 0 0 0', fontSize: '20px', color: '#494949', textTransform: 'uppercase' }}>The Graphē</h2>
                                            <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '400', color: '#858585' }}>A Design Studio</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', lineHeight: '20px', color: '#494949', width: '200px' }}>{selectedInvoice.template?.company_address || "N/A"}</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>GSTIN No. : <b>{selectedInvoice.template?.GSTIN}</b></p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>MSME No. : <b>{selectedInvoice.MSME_Number}</b> <small style={{ color: '#858585' }}>({selectedInvoice.MSME_Type})</small></p>
                                            {selectedInvoice.lut && (<p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>LUT No. : <b>{selectedInvoice.Lut_Arn_No}</b></p>)}
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "10px", textAlign: "right", verticalAlign: "top", width: "280px", paddingLeft: "65px" }} colspan="2" >
                                    <h3 style={{ margin: "5px 0 10px 0", fontSize: "26px", color: "#000" }}>{selectedInvoice.template_name}</h3>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ padding: "8px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ padding: "10px 15px 10px 10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Bill To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Poc : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.poc}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Email : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.email || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.phone || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>GSTIN :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.gstin || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_address || "N/A"}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="2" style={{ padding: "10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Ship To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_phone}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", lineHeight: "1.3", marginTop: "5px" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)", }}>
                                                {selectedInvoice.shipping_address}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="1" style={{ padding: "10px", verticalAlign: "top", width: "200px" }}>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Invoice # :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {selectedInvoice.invoice_code}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Issue Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.issue_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Due Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.due_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" style={{ padding: '10px 0' }}></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ backgroundColor: '#e7e7e7', textAlign: 'left' }}>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '230px' }}>Description</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>SAC/HSN</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Rate</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Qty</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '100px' }}>Sub Total</th>
                            </tr>
                            {selectedInvoice?.invoiceProducts?.map((product, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        <span style={{ display: 'block', marginBottom: '3px' }}>{index + 1}. {product.description}</span>
                                        {product.Remarks && (
                                            <small style={{ fontSize: '11px', lineHeight: '1.2' }} className="text-secondary d-block">
                                                <b>Remarks :</b> {product.Remarks}
                                            </small>
                                        )}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {product.hsn ? `HSN-${product.hsn}` : product.sac_code ? `SAC-${product.sac_code}` : '-'}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.price}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>{product.quantity}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.subtotal_price}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <th colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Subtotal:</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sub_total}</th>
                            </tr>
                            {selectedInvoice.tax_type === "Cgst+Sgst" && (
                                <>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>CGST ({selectedInvoice.cgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.cgst_value.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>SGST ({selectedInvoice.sgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sgst_value.toFixed(2)}</td>
                                    </tr>
                                </>
                            )}
                            {selectedInvoice.tax_type === "Igst" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>IGST ({selectedInvoice.igst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.igst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.tax_type === "GST" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>GST ({selectedInvoice.gst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.gst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.supplyAttractReverses === "Yes" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Supply Attract Reverse Charge :</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Yes</td>
                                </tr>
                            )}
                            <tr style={{ backgroundColor: '#e7e7e7' }}>
                                <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '18px' }}>Total:</td>
                                <td style={{ border: '1px solid #ddd', fontWeight: '600', padding: '6px 10px', fontSize: '18px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.total}</td>
                            </tr>
                            <tr>
                                <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                    <p style={{ margin: 0, fontSize: '13px' }}>
                                        Total amount (in words) : <span style={{ fontWeight: '500', paddingLeft: '5px' }}>{selectedInvoice.currency} {toWords(selectedInvoice.total).replace(/-/g, ' ').toUpperCase()} ONLY.</span>
                                    </p>
                                </td>
                            </tr>
                            {selectedInvoice.remarks && (
                                <tr>
                                    <td colSpan={5} style={{ padding: '10px 10px 10px 0', verticalAlign: 'top' }}>
                                        <p style={{ margin: 0 }}>
                                            <span style={{ fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Remarks :</span>
                                            <span style={{ fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>{selectedInvoice.remarks}</span>
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="5" style={{ padding: "10px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="3" style={{ padding: "15px 10px", verticalAlign: "top", borderTop: "1px solid #ddd" }}>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ paddingRight: "10px", textAlign: "center" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "12px", fontWeight: 600 }}>Pay Using UPI :</p>
                                            <img
                                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Graphe%CC%84%20QR%20Code.png?updatedAt=1743494152821"
                                                alt="UPI QR Code"
                                                style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                            />
                                            <small style={{ display: "block", fontSize: "12px", fontWeight: 400 }}>
                                                yashashwi.malani@okhdfcbank
                                            </small>
                                        </div>

                                        <div style={{ width: "calc(100% - 120px)", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "13px", fontWeight: 600 }}>Bank Details :</p>
                                            <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                <li style={{ display: "flex", marginBottom: "3px" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C Name :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)", lineHeight: 1.3 }}>
                                                        {selectedInvoice.template?.company_name || "N/A"}
                                                        <small style={{ margin: "2px 0 0px 0", fontSize: "11px", fontWeight: 400, color: "#858585", display: "block" }}>
                                                            Pay By CHEQUE/DD/RTGS/NEFT
                                                        </small>
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Bank :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_name || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C NO :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.account_number || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>IFSC :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.ifsc_code || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Branch :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_branch || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Swift Code :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.swift_code || "N/A"}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "15px 10px", textAlign: "right", verticalAlign: "top", borderTop: "1px solid #ddd" }} colSpan="2">
                                    <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                                        <div>
                                            <small style={{ marginRight: "50px" }}>
                                                <img
                                                    src="https://ik.imagekit.io/blackboxv2/Graphe-logo/stamp.jpeg?updatedAt=1737015027907"
                                                    alt="Stamp"
                                                    style={{ width: "80px", height: "80px", objectFit: "contain" }}
                                                />
                                            </small>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <p style={{ display: "block", fontSize: "14px", margin: "0 0 18px 0", fontWeight: 500 }}>
                                                <small>For The Graphē</small>
                                            </p>
                                            <img src={selectedInvoice.signature_url} alt="Signature" style={{ width: "80px", height: "80px" }} />
                                            <p style={{ display: "block", fontSize: "14px", margin: "18px 0 0 0", fontWeight: 400 }}>
                                                <small>Authorised Signatory</small>
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: "#f7f7f7" }}>
                                <td colSpan="5" style={{ padding: "10px 10px 0 10px", color: "#575757" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "13px", fontWeight: 600 }}>
                                        <span>Terms and Conditions : </span>
                                    </p>
                                    {[
                                        "Payment: Due within 7 days. Late payments attract interest as per the MSME Act, 2006.",
                                        "Interest on Late Payment: As per Section 16 of the MSME Act, 2006, delays beyond 45 days from the invoice date will attract interest at *24% P.A*",
                                        "Intellectual Property: Final designs are transferred upon full payment. Unpaid concepts remain the agency’s property.",
                                        "Revisions & Scope: Additional revisions beyond the agreed scope may be chargeable.",
                                        "Taxes: GST applicable as per law. Any tax changes are the client’s responsibility.",
                                        "Confidentiality: Both parties must maintain confidentiality unless agreed otherwise.",
                                        "Jurisdiction: Disputes fall under Kolkata, West Bengal, jurisdiction.",
                                        "Force Majeure: The agency isn’t liable for delays due to unforeseen circumstances."
                                    ].map((text, index) => (
                                        <p key={index} style={{ margin: "0 0 5px 0", fontSize: "12px", fontWeight: 400 }}>{index + 1}. {text}</p>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ backgroundColor: "#313030", padding: "10px 15px", textAlign: "center" }}>
                                    <small style={{ fontSize: "13px", fontWeight: 400, color: "#fff" }}>
                                        Call: {selectedInvoice.template?.contact_no || "N/A"} &nbsp;| &nbsp;
                                        Email: <a href={`mailto:${selectedInvoice.template?.email}`} style={{ color: "#fff" }}>{selectedInvoice.template?.email || "N/A"}</a>
                                    </small>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </Sidebar>

            <Sidebar visible={visibleRight2} position="right" onHide={() => setVisibleRight2(false)} style={{ width: '40vw' }}>
                <Card className="shadow-0">
                    <Card.Header className="d-flex align-items-center justify-content-end border-0 p-0 mb-4">
                        <Button
                            icon="pi pi-receipt"
                            label="View Invoice"
                            severity="warning"
                            className="py-2"
                            style={{ fontSize: "14px" }}
                            onClick={() => {
                                if (selectedLead?.invoice) {
                                    setSelectedInvoice(selectedLead.invoice); // ✅ Store lead’s invoice in state
                                }
                                setVisibleRight(true); // ✅ Then open the sidebar/modal
                            }}
                        />
                    </Card.Header>
                    <Card.Body>
                        <div className="allempList">
                            <div className="rol-title">Referral Details</div>
                            <Table borderless>
                                <thead>
                                    <tr>
                                        <th>Poc/Company Name</th>
                                        <td>{selectedLead?.lead_name || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Category</th>
                                        <td>{selectedLead?.lead_type || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Phone no</th>
                                        <td>{selectedLead?.phone_no || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Email</th>
                                        <td>{selectedLead?.email || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Requirement</th>
                                        <td>{selectedLead?.requirement || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Status</th>
                                        <td>{selectedLead?.status || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Submitted By</th>
                                        <td>{selectedLead?.leadOwner?.first_name || ""} {selectedLead?.leadOwner?.last_name || ""}</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div>

                        <div className="allempList">
                            <div className="rol-title">On-boarding Client Details</div>
                            <Table borderless>
                                <thead>
                                    <tr>
                                        <th>Client Name</th>
                                        <td>{selectedLead?.client?.Billing_name || "N/A"}</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div>

                        <div className="allempList">
                            <div className="rol-title">Conversion Info</div>
                            <Table borderless>
                                <thead>
                                    <tr>
                                        <th>Final Billing Amount</th>
                                        <td>{selectedLead?.final_amount || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Percentage (%)</th>
                                        <td>{selectedLead?.percentage || "N/A"}%</td>
                                    </tr>
                                    <tr>
                                        <th>Commission Amount</th>
                                        <td>{selectedLead?.commission_amount || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Conversion Date</th>
                                        <td> {selectedLead?.conversion_date
                                            ? new Date(selectedLead.conversion_date).toLocaleDateString('en-GB')
                                            : "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Payment Mode</th>
                                        <td>{selectedLead?.payment_mode || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Payment Status</th>
                                        <td>{selectedLead?.payment_status || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Payment Date</th>
                                        <td>{selectedLead?.payment_date
                                            ? new Date(selectedLead.payment_date).toLocaleDateString('en-GB')
                                            : "N/A"}</td>
                                    </tr>
                                </thead>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Sidebar>



        </>
    );
};

export default AdminLeadList;
